import React from 'react';
import { Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/scss/custom.scss';
import './App.css';
import NavBar from '@/components/layout/NavBar/NavBar';
import Homepage from '@/features/home/HomePage';
import About from '@/features/about/About';
import Policies from '@/features/policies/Policies';
import ProjectUpdates from '@/features/project-updates/ProjectUpdates';
import ContactInfo from '@/features/contact/ContactInfo';
import HuntClaimPage from '@/features/hunt-claim/HuntClaimPage';
import NotFound from '@/features/not-found/NotFound';
import Footer from '@/components/layout/Footer/Footer';

function App() {
    return (
        <div className="App">
            <header id="App-header">
                <NavBar />
            </header>
            <main id="App-main" className="">
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/policies/*" element={<Policies />} />
                    <Route
                        path="/project-updates"
                        element={<ProjectUpdates />}
                    />
                    <Route path="/contact" element={<ContactInfo />} />
                    {/* Where a phone camera lands after scanning a hunt
                        item's claim note. The claim code is after the # in
                        the link, so it never reaches the router. */}
                    <Route
                        path="/hunt/claim/:itemId"
                        element={<HuntClaimPage />}
                    />
                    {/* Any path not listed above. */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <footer id="App-footer">
                <Footer />
            </footer>
        </div>
    );
}

export default App;
